import { render } from "./DigitalTab.vue?vue&type=template&id=42202dbe"
import script from "./DigitalTab.vue?vue&type=script&lang=js"
export * from "./DigitalTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/DigitalTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42202dbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42202dbe', __exports__)) {
    api.reload('42202dbe', __exports__)
  }
  
  module.hot.accept("./DigitalTab.vue?vue&type=template&id=42202dbe", () => {
    api.rerender('42202dbe', render)
  })

}


export default __exports__